<template>
	<div class="page clearfix">

		<!-- 菜单 -->
		<div class="menu" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<div class="logo">
				<el-image class="icon" :src="qrData.institutionLogo" fit="fit" ></el-image>
				<div class="title">线上运维平台</div>
			</div>
			<menus :data="result"></menus>
		</div>

		<!-- 头部 -->
		<div class="header">
			<div class="breadcrumb">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item v-for="(breadcrumb,index) in breadcrumbList" :key="index">
						<template v-if="breadcrumb.url">
							<router-link :to="{ path: breadcrumb.url }">
								{{ breadcrumb.title }}
							</router-link>
						</template>
						<template v-else>
							<span>{{ breadcrumb.title }}</span>
						</template>
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<el-dropdown class="down_menu" @command="handleCommand">
				<span class="el-dropdown-link">
					<i class="iconfont icon-user"></i>
					{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="editPwd">修改密码</el-dropdown-item>
					<el-dropdown-item command="signOut">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div class="qr_div" @click="showQr" v-if="qrData">
				<vue-qr text="https://ems.zjkaies.com/download-h5/" :size="35" :margin="0" v-if="qrData.institutionLogo" />
				<vue-qr text="https://ems.zjkaies.com/download-h5/" :size="35" :margin="0" v-else />
			</div>
		</div>

		<!-- 内容主区域 -->
		<div class="content" style="overflow-y: auto;">
			<router-view></router-view>
		</div>

		<!-- 修改密码弹窗 -->
		<el-dialog title="修改密码" :visible.sync="dialogVisible" width="40%">
			<el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="100px">
				<el-form-item label="原密码" prop="oldPwd">
					<el-input type="password" v-model="form.oldPwd" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input type="password" v-model="form.newPwd" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkNewPwd">
					<el-input type="password" v-model="form.checkNewPwd" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="手机端二维码" :visible.sync="dialogQrVisible" width="500px">
			<div class="qr_dialog">
				<div class="qr" v-if="qrData">
					<vue-qr ref="qrCode" text="https://ems.zjkaies.com/download-h5/" :size="200" :margin="0" v-if="qrData.institutionLogo" />
					<vue-qr ref="qrCode" text="https://ems.zjkaies.com/download-h5/" :size="200" :margin="0" v-else />
				</div>
				<div class="tips">温馨提示：请使用安卓手机扫码下载最新应用版本</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogQrVisible = false">取 消</el-button>
				<el-button type="primary" @click="downloadQR">下 载</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import menus from "./menu";
	import eventBus from '@/components/libs/eventBus.js';
	import common from '@/common/common.js';
	import socket from '@/common/socket.js'
	import VueQr from 'vue-qr'

	export default {
		components: {
			menus: menus,
			VueQr
		},
		data() {
			var validateOldPwd = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入原始密码'));
				} else {
					callback();
				}
			};
			var validateNewPwd = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'));
				} else {
					callback();
				}
			};
			var validateNewPwd2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.newPwd) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				dialogQrVisible: false,
				qrUrl: "",
				result: [],
				menuName: null,
				menuUrl: null,
				dialogVisible: false,
				form: {},
				institutionForm: {},
				addTimeForm: {},
				index: {},
				breadcrumbList: [],
				rules: {
					oldPwd: [{
						validator: validateOldPwd,
						trigger: 'blur'
					}],
					newPwd: [{
						validator: validateNewPwd,
						trigger: 'blur'
					}],
					checkNewPwd: [{
						validator: validateNewPwd2,
						trigger: 'blur'
					}],
					cardNo: [{
						required: true,
						message: '卡号不能为空',
						trigger: 'change'
					}],
				},
				userName: '',
				loading: true,
				dialogInstitutionVisible: false,
				dialogAddTimeVisible: false,
				qrData: null,
				user_institutionId:null,
			};
		},
		methods: {
			refresh() {
				location.reload();
			},
			handleCommand(command) {
				var that = this;
				switch (command) {
					case 'editPwd':
						// 重置表单
						if (this.$refs.ruleForm != undefined) {
							this.$refs['ruleForm'].resetFields();
						}
						this.dialogVisible = true;
						break;
					case 'signOut':
						common.signOut(this);
						break;
					default:
				}
			},
			getQr() {
				this.$http({
					method: 'POST',
					url: 'mngr/cm/package/query',
					data: {
						currentPage: 1,
						pageSize: 1,
						status: 1,
						type:1,
						userInstitutionId:this.user_institutionId
					},
				}).then((res) => {
					if (res.data.data) {
						this.qrData = res.data.data[0]
						this.changeFavicon(this.qrData.institutionLogo);
					}
				})
			},
			showQr() {
				this.dialogQrVisible = true;
			},
			downloadQR() {
				const iconUrl = this.$refs['qrCode'].$el.src
				const link = document.createElement('a');
				link.href = iconUrl;
				var datas = this.qrData.url.split(".")
				var fileName = '手机端'
				if (this.qrData.institutionName) {
					fileName = this.qrData.institutionName;
				}
				fileName += "v" + this.qrData.version + "." + datas[datas.length - 1]
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			changeFavicon(iconPath) {
			  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			  link.type = 'image/x-icon';
			  link.rel = 'shortcut icon';
			  link.href = iconPath;
			  document.getElementsByTagName('head')[0].appendChild(link);
			},
			submitForm() { //修改密码
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let that = this;
						this.$http({
							method: 'POST',
							url: 'user/updatePassword',
							data: {
								oldPassword: this.form.oldPwd,
								password: this.form.checkNewPwd
							},
						}).then(function(res) {
							if (res.data.errorCode == '0000') {
								that.dialogVisible = false;
								that.$confirm('密码已修改需重新登录', '系统提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									common.signOut(that);
								});
							}
						})
					}
				});
			},
			getMenu() { //获取菜单列表
				let that = this;
				this.$http({
					method: 'POST',
					url: 'menus/tree',
					data: {},
				}).then(function(res) {
					if (res.data.errorCode == '0000') {
						that.result = res.data.data;
						that.loading = false;
						that.initSelect(null, res.data.data, that.$route.path)
					}
				})
			},
			initSelect(parent, list, toUrl) {
				if (list) {
					var that = this;
					list.forEach(item => {
						item.parent = parent;
						console.log(common.getToUrl(that, item.perUrl),toUrl)
						if (common.getToUrl(that, item.perUrl) == toUrl) {
							var menuId = sessionStorage.getItem("menuId")
							if (menuId = item.id) {
								common.initSessionStorage(item)
								eventBus.$emit('menuChange', {
									menuId: item.id,
									menuName: item.label,
									breadcrumbList: common.getBreadcrumbList(that, item)
								});
							}
							return true;
						}
						this.initSelect(item, item.children, toUrl)
						this.initSelect(item, item.hiddenChildren, toUrl)
					})
				}
			},
			successMessage(title, msg) { //成功提示
				this.$notify({
					title: title,
					message: msg,
					type: 'success'
				});
			},
			errorMessage(title, msg) { //失败提示
				this.$notify.error({
					title: title,
					message: msg,
					type: 'success'
				});
			},
		},
		computed: {
			foo() {
				return this.$store.state.menuName;
			}
		},
		watch: {
			foo(val) {
				this.menuName = val != '首页' ? val : null;
			}
		},
		mounted: function() {
			this.user_institutionId = sessionStorage.getItem('_institutionId');
			eventBus.$on('menuChange', (e) => {
				sessionStorage.setItem('menuName', e.menuName);
				this.menuName = e.menuName;
				console.log('menuChange', e.breadcrumbList)
				this.breadcrumbList = e.breadcrumbList;
			})
			this.getMenu();
			let userName = sessionStorage.getItem("_userName");
			this.userName = userName;
			this.getQr();
		},
		beforeRouteUpdate(to, from, next) {
			this.initSelect(null, this.result, to.path)
			next();
		},
		created: function() {
			let name = sessionStorage.getItem('menuName');
			if (name != null) {
				this.menuName = name;
			}
			socket.initWebSocket();
		}
	}
</script>

<style scoped>
	.page {
		width: 100%;
		height: 100%;
		min-width: 1280px;
	}

	.header {
		float: left;
		height: 50px;
		width: calc(100% - 202px);
		background: white;
		-webkit-box-shadow: 0 2px 2px 0 rgba(207, 216, 221, .7);
		-moz-box-shadow: 0 2px 2px 0 rgba(207, 216, 221, .7);
		box-shadow: 0 2px 2px 0 rgba(207, 216, 221, .7);
	}

	.menu {
		width: 200px;
		height: 100vh;
		float: left;
		overflow: auto;
		background-color: #2b2e3b;
	}

	.menu::-webkit-scrollbar {
		display: none;
	}

	.menu .logo {
		width: 100%;
		height: 50px;
		background: #15171d;
		text-align: center;
		line-height: 50px;
		font-size: 18px;
		color: #f1f1f1;
		/* background: #409EFF !important; */
	}
	.menu .logo .icon{
		width: 30px;
		height: 30px;
		margin-right: 5px;
		float: left;
		margin-top: 10px;
		margin-left: 18px;
	}
	.menu .logo .title{
		float:left;
		margin-left: 5px;
	}

	.content {
		float: left;
		height: 100vh;
		width: calc(100% - 201px);
		height: calc(100vh - 54px);
		box-sizing: border-box;
		/* overflow-y: hidden; */
		overflow-x: hidden;
		background-color: #f5f7f9;
		margin-top: 3px;
		/* overflow-y:auto; */
	}

	.el-breadcrumb {
		height: 49px;
		line-height: 49px;
		font-size: 15px;
	}

	.breadcrumb {
		float: left;
		margin-left: 20px;
		height: 49px;
		line-height: 49px;
	}

	.down_menu {
		float: right;
		height: 50px;
		line-height: 50px;
		margin-right: 10px;
		cursor: pointer;
		font-size: 16px;
		color: #555;
	}

	/deep/ .el-dropdown-menu__item {
		min-width: 100px;
	}

	.qr_div {
		float: right;
		margin-right: 10px;
		margin-top: 5px;
		cursor: pointer;
	}

	.qr_dialog {
		.qr {
			margin-left: 135px;
		}

		.tips {
			text-align: center;
			margin-top: 20px;
			color: #EF1A1A;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/layout/Main.vue